import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-41">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-42">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-sage-light/40 blur-3xl" data-id="element-43" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-sage-light/30 blur-3xl" data-id="element-44" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-45">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-46">
          <div className="max-w-2xl" data-id="element-47">
            <FadeIn data-id="element-48">
              <span className="inline-block py-1 px-3 rounded-full bg-sage-light text-brown text-sm font-semibold tracking-wider uppercase mb-6" data-id="element-49">
                Método Biológico
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-50">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" data-id="element-51">
                El Protocolo Cortisol Off™: Desinflama tu vientre bajo en 7
                días
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-52">
              <p className="text-xl md:text-2xl font-serif italic text-sage mb-6" data-id="element-53">
                (Sin pasar hambre ni matarte en el gimnasio)
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-54">
              <h2 className="text-lg md:text-xl text-brown/80 mb-10 leading-relaxed" data-id="element-55">
                El método biológico para "apagar" la hormona del estrés que
                mantiene tu abdomen hinchado y recuperar tu energía de los 20s.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-56">
              <CTAButton href="#precio" data-id="element-57">
                ¡SÍ, QUIERO EL PROTOCOLO AHORA!
              </CTAButton>
              <div className="flex flex-col" data-id="element-58">
                <span className="text-2xl font-bold text-brown" data-id="element-59">
                  $10.99 USD
                </span>
                <span className="text-sm text-brown/70" data-id="element-60">
                  Precio Especial de Lanzamiento
                </span>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.3} direction="left" className="relative lg:ml-auto" data-id="element-61">
            <div className="relative w-full max-w-md mx-auto aspect-[4/5] animate-float" data-id="element-62">
              {/* Soft glow behind image */}
              <div className="absolute inset-0 bg-sage-light rounded-3xl blur-2xl transform scale-95 opacity-60" data-id="element-63" />
              <img src="https://cdn.magicpatterns.com/uploads/4xnujm8VD2ap5cfuuq1GHN/protocolo_cortisol.png" alt="Portada del Protocolo Cortisol Off" className="relative z-10 w-full h-full object-contain drop-shadow-2xl rounded-2xl" data-id="element-64" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}